import React from 'react';
import Modal from '@components/common/Modal';
import { getObjectValue } from '../../utility/utills';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import deleteLogo from '@assets/images/delete.svg';
import editLogo from '@assets/images/edit/edit.svg'
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import cn from 'classnames';
import styles from './stage.module.scss';


const Stage = (props) => {

  // Props Destructuring
  const {
    availableSeats,
    addToSeatList,
    seatList,
    stageBtn,
    isModalOpen,
    setModalOpen,
    setSeatDeleteModal,
    setIsEditModalOpen,
    stagePayment,
    tableData,
    setTempObject,
    removeFromStage,
    currencySymbol,
    handleStageMove,
    handleStageSelection,
    selectedStage,
    handleCheckItems,
    handleItemSelection,
    selectedItem,
    auth,
    node,
    userInfo,
    seat,
    serverAppTheme
  } = props

  let count = 0;

  // Methods
  const returnName = (arr, idval) => {
    const found = arr.find((item) => item.id === idval);
    if (found.name !== null && found.name !== '') {
      return `${found.name}`;
    }
    return null;
  };

  const ItemList = (items) => {
    return items.length > 0 ? items.map((i, index) => {
      return (
        <div
          className={cn('d-flex p-0 m-0 row fs_14 fw-500 p-2 mb-2 rounded border-0', styles.stageItemList)}
          style={{background: serverAppTheme?.send_tab_unselected, color: serverAppTheme?.primary_text}}
        >
          {!(i.discount || i.service) ? (
            <div className="col-1 p-0 bg-transparent d-flex align-items-center">
              <input
                type="checkbox"
                id={i.id}
                onChange={() => { }}
                className={cn(styles.checkbox)}
                onClick={(e) => handleCheckItems(i, e.target.checked, index)}
                checked={i.isCheck || false}
                style={{border:!i.isCheck ? serverAppTheme?.checkbox_border : 'none', '--checkbox-checked-color':'#fff'}}
              />
            </div>
          ) : (
            <div className="col-1 p-0" />
          )}
          <div
            className={cn('d-flex col-11 fs_14 pl-2 pr-0 m-0 align-items-center')}
            role="presentation"
            onClick={() => handleItemSelection(i)}
          >
            <div className={cn(node === 0 && 'col-1 text-center pr-2', node === 1 && !auth?.serverAppFeatures.displayPrice ? 'col-4 text-center' : 'col-1 text-center mr-2', 'fw-500 p-0')}>{i.seats && i.seats.length > 0 && i.seats[0].splitValue > 1  && i.quantity ? `${i.quantity}/${i.seats[0].splitValue}` : i.quantity}</div>
            <div className="col px-1">{i.menuItemName}</div>
            {i?.seats? 
            <div className='col-2 px-0 d-flex justify-content-center align-items-center'>
              <div className=' fs_16 fw-500 w-70 h-80 rounded d-flex justify-content-center align-items-center' style={{color: serverAppTheme?.seat_box_text, background: serverAppTheme?.seat_bg}}>{i?.seats?.length > 1 ? i?.seats[0]?.tableOrder ? 'T' : 'S' : seat?.seats?.filter((it) => it?.id === i?.seats[0]?.seatId)[0].number}</div>
            </div> :
            <div className='col-2 px-0 d-flex justify-content-center align-items-center'>
              <div className=' fs_16 fw-500 w-70 rounded d-flex justify-content-center align-items-center h-80' style={{color: serverAppTheme?.seat_box_text, background: serverAppTheme?.seat_bg}}>{i?.seatIds?.length > 1 ? '1/' + (i?.seatIds?.length) : check?.seats?.filter((it) => it?.id === i?.seatIds[0])[0]?.number}</div>
            </div>}
            {i?.discountId ? <div className="col-3 p-0 text-right pl-2 fs_12">-{currencySymbol}{i.price.toFixed(2)}</div> : <div className="col-3 p-0 text-right pl-2 fs-14">{currencySymbol}{i.price.toFixed(2)}</div>}
          </div>
          {[selectedItem].some((e) => e.id === i.id) && items.filter((e) => e.isCheck).length === 0 && (
            <div className="col-12 m-0 p-1 row mx-0 justify-content-center">
              <button
                type="button"
                className={cn('rounded btn-ripple my-1 fs_16 fw-600 w-100')}
                onClick={() => handleStageMove()}
                style={{backgroundColor: serverAppTheme?.secondaryBtn , color:'#ffff',border: 0, height:'6.2vh'}}
              >
                {LABEL().MOVE}
              </button>
            </div>
          )}
        </div>
      );
    }) : <div className="h-100 fs_18 row mx-0 align-items-center justify-content-center" style={{color: serverAppTheme?.input_placeholder}}>{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>;
  };

  const getStageSplitValidation = () => {
    let value =false;
    seat?.tickets.forEach((val) => {
      if (!val.preAuth && val.splitValue === 1) {
        value = false;
      }
    })
    return value
  }
  
  const displayDelete = (item) => {
    if (!availableSeats.includes(item.id) && item.open) {
      count++
      return true;
    }
  }
  // HTML CSS CODE

  return (
    <div className={cn('col-12 col-md-12 p-0 row mx-0 h-100', userInfo?.flipView ?'rowReverse' :'')} style={{backgroundColor: serverAppTheme?.background_color, color: serverAppTheme?.primary_text}}>
      {tableData ? (
        <>
          <div className={cn('col-12 col-md-8 pr-1 py-4 h-100 pl-15', styles.cardPadding)}>
            <div className={cn('row mx-0 h-100 p-0 rounded  rowReverse',styles.bodyBackground)} style={{background: serverAppTheme?.selector_control_color}}>
              <div className={cn('col-12 col-md-6 pt-4 pb-2 px-2 h-100')} style={{ width: '50%', overflowX: 'scroll' }}>
                <div className={cn('col-12 m-0 p-0 fs_16 fw-500 ml-0  lh-base')}>{CUSTOM_MESSAGES().SELECT_SEATS_CLICK_STAGE}</div>
                <div className={cn('d-flex flex-wrap ml-0 mb-1 ', styles.wrapper)} style={{maxHeight:'30vh', overflowY:'auto'}}>
                  {tableData?.seats?.filter((e) => e.open)?.length > 0 && tableData?.seats?.map((item) => {
                    return !availableSeats.includes(item.id) && item.open && (
                      <div key={item.id} className="d-flex my-2">
                        <div role="presentation" onClick={() => { addToSeatList(item.id); }} className={cn('rounded mr-1', styles.stageNo, seatList.includes(item.id) ? `${styles.seletedSeat}` : `${styles.unSeletedSeat}`)} style={{background:seatList.includes(item.id) ? serverAppTheme?.primaryBtn : serverAppTheme?.tip_tile, border:seatList.includes(item.id) ? 'none': `1px solid ${serverAppTheme?.stage_seat_border}`, color: seatList.includes(item.id) ? 'white' : serverAppTheme?.primary_text}}>
                          <div className="fs_18 fw-600 text-center d-flex align-items-center justify-content-center" style={{height:'7vh',minWidth:'7vh'}}>{item.number}{returnName(tableData.seats, item.id) ? (
                            <span>(
                              <span className={styles.truncate}> {returnName(tableData.seats, item.id)}
                              </span>)
                            </span>) : ' '}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {tableData?.seats?.filter((e) => e.open)?.length > 0 && tableData?.seats?.map((item, index) => {
                    return displayDelete(item) && count == 1 && (<button 
                    type="button"
                    className={cn(
                      styles.btnDelStyle,
                      'fs-15 col-1  btn-ripple text-center  my-2 py-1 px-2 rounded color-white'
                    )} style={{backgroundColor: serverAppTheme?.primaryBtn,height:'7vh',minWidth:'7vh', fontSize: '2rem'}}>
                    <img
                      role="presentation"
                      src={deleteLogo}
                      fill="white"
                      alt="delete"
                      onClick={() => {
                        setSeatDeleteModal(true)
                      } }                         
                      className={cn(
                        'text-center fs-16 btn-ripple rounded fw-700'
                    )} />
                    </button>)})}
                </div>
                <div className='col-12 row px-0 m-0'>
                  {stageBtn?.map((btn, index) => {
                    return (
                      <div key={btn.name} className={cn(index < 2 ? (index==1? 'col-md-6 pl-1 pr-0': 'col-md-6 pr-1 pl-0') : 'col-12 px-0')}>
                        <button type="button" onClick={() => { btn.click(); }} className={cn('text-center fs_24 mb-2 btn-ripple fw-600 w-100 px-0', styles.stagePaymentBtnCopy, styles.disabledBtn)} style={{ lineHeight: '18px', background: serverAppTheme?.primaryBtn, '--disabled-primarybtn': serverAppTheme?.primary_btn_disable, '--disabled-btntext': serverAppTheme?.menu_btn_disable_text }} disabled={(index === 4 && seat.paymentStages.length) || (index === 4 && seat?.tickets.length > 0 && getStageSplitValidation()) }>{btn.name}</button>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={cn('col-12 col-md-6 p-1 h-100')}>
                <div className="row mx-0 h-100 p-1 rounded">
                  {tableData.paymentStages && Object.values(tableData.paymentStages).length > 0 ? (
                    <div className={cn('col-12 col-md-12 p-0 overflowY overflowXHidden h-90')} style={{marginTop:'38px'}}>
                      {tableData.paymentStages && Object.values(tableData.paymentStages).map((item) => {
                        return Number(item.status) === 0 && (
                          <div key={item.id} role="presentation" onClick={() => handleStageSelection(item)} className={cn('mb-2', selectedStage === item.id ? ` ${styles.selectedStagedCard}` : ` ${styles.stagedCard}`)}
                          style={selectedStage === item.id ? {border: `1px solid ${serverAppTheme?.survey_select_border}`, background: serverAppTheme?.stage_tab_button_selected} : {background: serverAppTheme?.stage_tab_button, border:'none'}}
                          >
                            <div className="col-12 p-1 d-flex align-items-center ">
                              <div className="m-0 row col px-1 d-flex align-items-center">
                                <div className='row col fs_12 fw-500 p-0 m-0'>
                                {item?.seats?.map((data,index) => {
                                  const seat = tableData?.seats?.find((e) => e.id === data?.seatId);
                                  return seat &&(
                                    <div key={data.id} className={cn('rounded fs_16 text-center mr-1 fw-500 color-white', styles.stageNumberBtn, selectedStage === item.id ? '' : ` ${styles.stageNumberBtn}`)} style={{background:serverAppTheme?.stage_table_number}}>
                                      <span style={{verticalAlign:'revert'}}>{seat.number}</span> {seat.name ? (
                                        <span>(
                                          <span className={styles.truncate}>{seat?.name}
                                          </span>)
                                        </span>) : seat.name }
                                    </div>
                                  );
                                })}
                                {item?.name?.length > 0 && <div className='my-auto mx-1'><span className={styles.truncate}>{item.name}</span></div>} </div>
                                <label className="col-4 fs_16 fw-400 m-0 p-0 text-right">{item.totalAmount ? `${currencySymbol}${Number(item.totalAmount).toFixed(2)}` : ''}</label>
                              </div>
                              <div className='col-1 p-0 mx-1 my-0 d-flex justify-content-center' style={{backgroundColor: serverAppTheme?.primaryBtn, borderRadius:'2px', fontSize: '1.2rem'}}>
                                <img 
                                  src={editLogo} 
                                  style={{padding:'4px'}} 
                                  alt="edit"
                                  tabIndex="0"
                                  role="button"
                                  onClick={() => { setTempObject(item); setIsEditModalOpen(true); }}
                                />
                              </div>
                              <div
                                className="col-1 p-0 mx-1 my-0 d-flex justify-content-center"
                                style={{
                                  backgroundColor: serverAppTheme?.primaryBtn,
                                  borderRadius: "2px",
                                  fontSize: "1.2rem",
                                }}
                              >
                                <img
                                  src={deleteLogo}
                                  fill="white"
                                  style={{ padding: "4px" }}
                                  alt="delete"
                                  tabIndex="0"
                                  role="button"
                                  onClick={() => {
                                    setTempObject(item);
                                    setModalOpen(true);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>) : <div className="col-12 row mx-0 align-items-center justify-content-center fs_16 fw-500 h-100" style={{color: serverAppTheme?.noRecord}}>{LABEL().NO_STAGES}</div>}
                </div>
              </div>
            </div>
          </div>
          <div className={cn('col-12 col-md-4 pl-1 py-4 h-100 pr-10', styles.cardPadding)} style={{}}>
            <div className={cn('row h-100 mx-0 rounded')} >
            {tableData?.paymentStages[selectedStage]?.items?.length > 0 && <div
              className={cn(
                'col-12 row mx-0 w-100 align-content-center fw-400 fs_12 pl-2 pr-0',
              )} 
              style={{fontFamily: 'Poppins', color: serverAppTheme?.secondary_text, marginBottom:'8px'}}
            >
              <div className="col-1" />
              <div className='col-11 pr-0 row'>
                <div className="col-1 text-center mr-1 p-0">
                  {' '}
                  <span> {LABEL().QTY}</span>
                </div>
                <div className="col p-0 text-left">
                  <div className="mx-0 px-2">
                    {LABEL().ITEMS_LIST}
                  </div>
                </div>
                <div className="col-2 p-0 text-center">
                  {' '}
                  <span>{LABEL().ITEMS_SEAT}</span> 
                </div> 
                <div className={cn('col-3 p-0 text-right')}>
                  <span>{LABEL().AMOUNT}</span>
                </div>
              </div>
            </div>}
              <div className={cn('col-12 col-md-12 p-0 overflowY overflowXHidden', getObjectValue(() => tableData.paymentStages[selectedStage].items.filter((e) => e.isCheck).length > 0, false) ? 'h-68' : 'h-80')}>
                {tableData?.paymentStages[selectedStage] ? ItemList(tableData?.paymentStages[selectedStage]?.items) : <div className="col-12 h-100 row mx-0 fs_16 fw-500 align-items-center justify-content-center text-center " style={{color: serverAppTheme?.input_placeholder}}>{CUSTOM_MESSAGES().PLEASE_SELECT_A_STAGE_TO_SEE_ITEMS}</div>}
              </div>
              <div className={cn('col-12 px-0 row mx-0 align-items-end justify-content-end')}>
                {getObjectValue(() => tableData.paymentStages[selectedStage].items.filter((e) => e.isCheck).length > 0, false) && (
                  <button
                    type="button"
                    className={cn(' btn-ripple m-1 w-100', styles.divForPaymentCopy)}
                    style={{backgroundColor: serverAppTheme?.secondaryBtn, color: 'white', height:'10.5vh', borderRadius:'4px', border:'0'}}
                    onClick={() => handleStageMove()}
                  >
                    <div className="fs_24 fw-600">{LABEL().MOVE}</div>
                  </button>
                )}
                <button
                  type="button"
                  className={cn(' btn-ripple mx-1 w-100', styles.divPaymentCopy, styles.disabledBtn)}
                  style={{backgroundColor: serverAppTheme?.secondaryBtn, '--disabled-primarybtn': serverAppTheme?.secondary_btn_disable, '--disabled-btntext': serverAppTheme?.secondary_btn_disable_text, color: 'white', height:'10.5vh',borderRadius:'4px'}}
                  onClick={() => stagePayment()}
                  disabled={!(tableData.paymentStages && Object.values(tableData.paymentStages).length > 0)}
                >
                  <div className="fs_24 fw-600">{LABEL().PAYMENT}</div>
                </button>
              </div>
            </div>
          </div>
        </>
      ) : <div className="position-fixed fw-700 fs-26 " style={{ top: '45%', left: '20%' }}>{CUSTOM_MESSAGES().ORDER_FOR_STAGE}</div>}
      
<Modal
          isOpen={isModalOpen}
          isModalCenter
          style={{backgroundColor: serverAppTheme?.popUp_bg, border:serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, borderRadius:'16px', width: '486px', margin:'auto', minHeight:"216px"}}
          customClass='h-100 w-100'  customClass2='h-100 w-100'
          noBackground
        >         
          <div className="justify-content-center align-items-center text-center h-100" style={{padding:'24px', color: serverAppTheme?.primary_text}}>
            <span className="col-1 fs-20 float-right position-absolute" role="presentation" style={{top:'4px',right:'8px'}}>
              <Cross fill={serverAppTheme?.iconcolor}  onClick={() => { setModalOpen(false); }} style={{height:'28px', width:'28px'}}/>
            </span>
            <div className='col-11 ml-4 py-2 fs_18 fw-700 text-center h-25'>Are You Sure?</div>
              <div className="col-12 d-flex p-0 py-1 h-auto justify-content-center">
                <div className="col-9 fs_14 fw-500 text-center ">
                  {CUSTOM_MESSAGES().DELETE_STAGE}
                </div>
              </div>
              <div className="col-11 d-flex mt-2 justify-content-center align-items-center align-items-end text-center h-20 position-absolute" style={{bottom:'26px',left:'20px'}}>
                <button className={cn("col-6 h-100 mr-1 btn90 fs_28")} style={{border: serverAppTheme?.cancleBtn_Border, background:serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font}} type="button" onClick={() => setModalOpen(false)}>
                  {LABEL().NO}
                </button>
                <button className={cn("col-6 h-100 ml-1 btn90 btn-ripple fs_28", styles.yesBtn)} style={{backgroundColor: serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color}} type="button" onClick={() => { removeFromStage() }}>
                  {LABEL().YES}
                </button>
              </div>
            </div>
        </Modal>
    </div>
);
};

export default Stage;
